import Vue from 'vue'
import Cosmopolitan from '@holaluz/cosmopolitan'
import '@holaluz/cosmopolitan/dist/cosmopolitan.css'

Vue.use(Cosmopolitan)
